<script setup lang="ts">
const { title, dark = false } = defineProps<{
  title: string
  dark?: boolean
}>()

const loginPageUrl = useLoginPageUrl()
const route = useRoute()

const redirectUrl = computed(() => {
  const encodedFromPath = encodeURIComponent(route.fullPath)

  if (loginPageUrl.value) {
    return {
      path: loginPageUrl.value,
      query: {
        fromPath: encodedFromPath,
      },
    }
  } else {
    return undefined
  }
})
</script>

<template>
  <p
    class="font-national2 text-sm font-bold md:text-base"
    :class="{
      'text-white': dark,
      'text-[--theme-dark]': !dark,
    }"
  >
    Kjøp tilgang for å se innholdet.
    <br class="block lg:hidden" />
    <span class="whitespace-nowrap font-normal">
      Allerede tilgang?
      <UButton
        v-if="redirectUrl"
        :to="redirectUrl"
        variant="quite"
        size="sm"
        :theme="dark ? 'light' : 'medium'"
        class="!inline !text-sm underline md:text-base [&>*]:inline"
        :aria-label="`Logg inn for å få tilgang til artikkelen ${title}`"
      >
        Logg inn
      </UButton>
      <template v-else>Logg inn</template>
    </span>
  </p>
</template>
